<template>
  <el-dialog
    title="Add Kid"
    :visible.sync="showDlg"
    :append-to-body="true"
    :lock-scroll="false"
    width="50%"
  >
    <div v-if="getParentPasscode === null" :class="formCssClass">
      <img
        class="centerImage mb-4"
        src="../../.../../../assets/images/passcode.svg"
        width="140`"
      />
      <div style="text-align: center" class="mb-4 mt-4">
        <p style="font-size:16px">
          To use this feature, enter the parent passcode shared with you by the
          school:
        </p>
        <el-input
          size="large"
          v-model="passcode"
          type="password"
          @keyup.enter.native="fnValidatePasscode()"
          autofocus
          style="width: 300px; margin-top: 25px"
        >
          <i slot="prefix" class="el-input__icon material-icons input-icon"
            >lock_outline</i
          >
        </el-input>
      </div>
      <div class="centerFlex mt-1">
        <el-button
          type="primary"
          @click="fnValidatePasscode"
          :disabled="apiCheckPasscodeInProgress || passcode.length === 0"
          >Unlock feature</el-button
        >
      </div>
    </div>
    <div v-else>
      <template v-if="!apiFetchedPeopleOptions">
        <div v-loading="!apiFetchedPeopleOptions" style="height: 300px"></div>
      </template>
      <template v-else>
        <div
          class="ui grey message"
          style="margin-top: 0px;"
          v-if="kidInfoIsEditable"
        >
          <span v-if="bAddFromExistingKidsMode"
            >Select your child and verify the grade/teacher information for this
            yearbook:</span
          >
          <span v-else>Enter the school year information for your child:</span>
          <ul style="margin-left: 30px;margin-top: 15px;">
            <li>
              Choose <strong>Not Applicable</strong> if a grade/teacher does not
              apply.
            </li>
            <li>
              If the option for your child's grade/teacher is missing, you can
              add it yourself.
            </li>
          </ul>
        </div>
        <el-form
          ref="form"
          :disabled="apiVerifyKidInformationInProgress || apiAddKidInProgress"
          :model="form"
          :rules="formRules"
          label-width="120px"
          label-position="left"
          v-on:validate="onFormValidate"
        >
          <el-form-item label="Yearbook">
            <strong>{{ getStorefrontBookName }}</strong>
          </el-form-item>
          <el-form-item label="School">
            <strong>{{ getStorefrontSchoolName }}</strong>
          </el-form-item>
          <div v-show="!bAddFromExistingKidsMode">
            <el-form-item
              label="First name"
              prop="first_name"
              class="mykids-form-item"
              :show-message="false"
            >
              <el-input v-model="form.first_name"></el-input>
            </el-form-item>
            <el-form-item
              label="Last name"
              prop="last_name"
              class="mykids-form-item"
              :show-message="false"
            >
              <el-input v-model="form.last_name"></el-input>
            </el-form-item>
          </div>
          <el-form-item
            label="My Kid"
            class="is-required mykids-form-item"
            prop="kid"
            :show-message="false"
            v-show="bAddFromExistingKidsMode"
          >
            <el-select
              v-model="selectedKidId"
              placeholder="Choose from My Kids"
              @change="fnOnKidSelectChange"
            >
              <el-option
                v-for="item in options.kids"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <template v-if="bAddFromExistingKidsMode && !kidInfoIsEditable">
            <template v-if="selectedKidId">
              <el-form-item label="Teacher">
                <strong>{{
                  form.teacher_name === "n/a"
                    ? "Not Applicable"
                    : form.teacher_name
                }}</strong>
                <span @click="bReadOnlyExistingKidMode = false">
                  <el-icon
                    name="edit-outline"
                    class="ml-2"
                    style="color:#409eff; cursor:pointer"
                  ></el-icon>
                </span>
              </el-form-item>
              <el-form-item label="Grade">
                <strong>{{
                  form.grade === "n/a" ? "Not Applicable" : form.grade
                }}</strong>
                <span @click="bReadOnlyExistingKidMode = false">
                  <el-icon
                    name="edit-outline"
                    class="ml-2"
                    style="color:#409eff;cursor:pointer"
                  ></el-icon>
                </span>
              </el-form-item>
            </template>
          </template>
          <div v-show="kidInfoIsEditable">
            <el-form-item
              label="Teacher"
              prop="teacher_name"
              class="mykids-form-item"
              :show-message="false"
            >
              <el-select
                v-model="form.teacher_name"
                filterable
                allow-create
                default-first-option
                placeholder="Choose teacher"
              >
                <el-option
                  v-for="item in options.teacher_name"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="Grade"
              prop="grade"
              :show-message="false"
              class="mykids-form-item"
            >
              <el-select
                v-model="form.grade"
                filterable
                allow-create
                default-first-option
                placeholder="Choose grade"
              >
                <el-option
                  v-for="item in options.grade"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <div class="ui blue message" v-if="showTipAddMissingGradeTeacher">
              <div
                class="close icon"
                @click="showTipAddMissingGradeTeacher = false"
              >
                <i class="fas fa-times"></i>
              </div>
              <i class="far fa-lightbulb mr-2"></i>
              <strong>Tip:</strong> To add a missing teacher/grade, type in the
              dropdown box and <strong>press enter</strong>.
            </div>
          </div>
        </el-form>
        <div v-if="apiVerifyKidInformationInProgress">
          <div class="ui blue message">
            <el-icon name="loading mr-2"></el-icon>Searching for
            <strong>{{ form.first_name }} {{ form.last_name }}</strong> in the
            yearbook...
          </div>
        </div>
        <div class="ui green message" v-if="kidLookupMatch">
          <el-icon name="success"></el-icon>
          <strong class="ml-2">Yearbook Match Found</strong>. The information
          above matches the school's yearbook record. Click
          <strong>Add Kid</strong> to continue.
        </div>
        <div class="ui yellow message" v-if="kidLookupNoMatch">
          <div v-if="!strCustomErrorMessage">
            <el-icon name="warning"></el-icon>
            <strong class="ml-2">No yearbook match found.</strong> This might be
            because:
            <ul
              style="margin-left: 30px;
      margin-top: 15px;
      margin-bottom: 15px;"
            >
              <li>
                The school has not yet added your child's information to the
                yearbook.
              </li>
              <li>
                The information you have entered is incorrect or does not match
                the school's record (double check it for typos)
              </li>
            </ul>
            <p>
              If you continue to get this message and you believe your
              information to be correct, click <strong>Add Kid</strong>.
            </p>
          </div>
          <div v-else>
            <el-icon name="warning"></el-icon> {{ strCustomErrorMessage }}
            <p style="margin-top:15px" v-if="!bErrorStateIsBlocking">
              Click <strong>Add Kid</strong> to save this information.
            </p>
          </div>
        </div>
      </template>
    </div>
    <span slot="footer" class="dialog-footer" v-if="getParentPasscode">
      <el-button @click="showDlg = false">{{ $t("cancel") }}</el-button>
      <el-button
        type="primary"
        :disabled="
          !formIsValid ||
            apiVerifyKidInformationInProgress ||
            apiAddKidInProgress ||
            bErrorStateIsBlocking
        "
        @click="fnOnClickAddKid"
        >Add Kid</el-button
      >
    </span>
  </el-dialog>
</template>

<script type="text/babel">
import { mapActions, mapGetters } from "vuex";
import {
  validateParentPasscode,
  getPeopleOptions,
  verifyKidInformation
} from "@/modules/shop/api";
import { httpStatusException } from "../../../api";
export default {
  name: "addChildrenToOrderDialog",
  components: {},
  data() {
    return {
      formCssClass: "",
      passcode: "",
      apiVerifyKidInformationInProgress: false,
      apiCheckPasscodeInProgress: false,
      apiAddKidInProgress: false,
      apiFetchedPeopleOptions: false,
      bErrorStateIsBlocking: false,
      form: {
        first_name: "",
        last_name: "",
        teacher_name: "",
        grade: ""
      },
      formIsValid: false,
      formRules: {
        first_name: [
          {
            required: true,
            trigger: "blur"
          }
        ],
        last_name: [
          {
            required: true,
            trigger: "blur"
          }
        ],
        teacher_name: [
          {
            required: true,
            trigger: "change"
          }
        ],
        grade: [
          {
            required: true,
            trigger: "change"
          }
        ]
      },
      options: {
        teacher_name: [],
        grade: [],
        kids: []
      },
      kidLookupMatch: false, // kid info matches against people DB
      kidLookupNoMatch: false, // kid info DOES NOT match against people DB
      bAddFromExistingKidsMode: false, // pick from existing kids mode
      bReadOnlyExistingKidMode: true, // editing kids info in existing kids mode
      strCustomErrorMessage: null,
      selectedKidId: null,
      showTipAddMissingGradeTeacher: true // show tip for adding a new grade/teacher
    };
  },
  computed: {
    // map store getters to local computed properties:
    ...mapGetters([
      "showAddChildrenToOrderDialog",
      "getParentPasscode",
      "getStorefrontId",
      "getOrder",
      "getOrderId",
      "getOrderKids",
      "getStorefrontBookId",
      "showAddChildrenToOrderDialogParams",
      "getKidsInfo",
      "getStorefrontBookName",
      "getStorefrontSchoolName"
    ]),
    showDlg: {
      get() {
        return this.showAddChildrenToOrderDialog;
      },
      set() {
        this.uiHideAddChildrenToOrderDialog();
      }
    },
    kidInfoIsEditable() {
      if (!this.bAddFromExistingKidsMode) {
        return true;
      } else {
        return (
          this.selectedKidId !== null && this.bReadOnlyExistingKidMode === false
        );
      }
    }
  },
  methods: {
    ...mapActions([
      "uiHideAddChildrenToOrderDialog",
      "setParentPasscode",
      "fetchOrder",
      "getKids",
      "createKid",
      "addKidToOrder",
      "updateKidInfo"
    ]),
    fnCloseDlg() {
      this.showDlg = false;
    },
    // validates the parent passcode
    // dialog is locked until this is valid
    async fnValidatePasscode() {
      this.apiCheckPasscodeInProgress = true;
      try {
        await validateParentPasscode(this.getStorefrontId, this.passcode);
        this.setParentPasscode(this.passcode);
        await this.fnInitUiOptions();
      } catch (err) {
        this.formCssClass = "shakeanim";
        setTimeout(() => {
          this.formCssClass = "";
        }, 1000);
      } finally {
        this.apiCheckPasscodeInProgress = false;
      }
    },
    async fnInitUiOptions() {
      // once the passcode has been validated, we need to
      // fetch data to populate various UI components
      try {
        // firstly, populate the grade/teacher dropdown boxes
        // based upon the portraits DB
        const res = await getPeopleOptions(
          this.getStorefrontId,
          this.getParentPasscode
        );
        this.options.teacher_name = res.options.teacher_name.map(attribute => ({
          value: attribute,
          label: attribute
        }));
        this.options.grade = res.options.grade.map(attribute => ({
          value: attribute,
          label: attribute
        }));
        // in some situations, grade/teacher will not have any values (e.g. pspa not imported)
        // also, in some schools, only one option is applicable
        // n/a is basically our user-friendly 'null' option to handle these cases,
        // which works with the form validation
        const optionNotApplicable = { value: "n/a", label: "Not applicable" };
        this.options.teacher_name.push(optionNotApplicable);
        this.options.grade.push(optionNotApplicable);
        // if the dialog is in a "Select from existing kids mode",
        // fetch the parent's kids from the api
        // so we can populate the select dropdown
        if (this.showAddChildrenToOrderDialogParams === "existing") {
          this.bAddFromExistingKidsMode = true;
          try {
            await this.getKids();
            const kidIdsInOrder = this.getOrderKids.map(kid => kid.id);
            // remove kids that are already in the order
            // remove kids that do not belong to this book
            this.options.kids = this.getKidsInfo
              .filter(kid => kidIdsInOrder.indexOf(kid.id) === -1)
              .filter(kid => kid.book_id === this.getStorefrontBookId)
              .map(kid => ({
                value: kid.id,
                label: kid.full_name
              }));
          } catch (err) {
            console.log(err);
            this.fnAbortOnExceptionHandler();
          }
        }
        this.apiFetchedPeopleOptions = true;
      } catch (err) {
        console.log(err);
        this.fnAbortOnExceptionHandler();
      }
    },
    async fnVerifyKidInformation() {
      try {
        // when ever we have all data for the kid entered,
        // we block the UI and verify the information against
        // the people DB
        // for privacy reasons, we cannot show a list of
        // kid names + grade/teacher, so instead, we
        // provide a lookup service which informs the user
        // IF their current information matches the DB

        // it's important to note that in many scenarios
        // we will not have a person DB match - e.g. pspa not imported,
        // kid does not exist in the book,
        // information has beeen mis-entered.
        this.apiVerifyKidInformationInProgress = true;
        this.kidLookupMatch = false;
        this.kidLookupNoMatch = false;
        let oRequest = Object.assign({}, this.form);
        if (oRequest.grade === "n/a") oRequest.grade = null;
        if (oRequest.teacher_name === "n/a") oRequest.teacher_name = null;
        // let the server know whether we are validating an existing kid
        // since this changes how it handles the error control
        // for duplicate kids
        if (this.selectedKidId) {
          oRequest["existing_kid_id"] = this.selectedKidId;
        }
        await verifyKidInformation(
          this.getStorefrontId,
          this.getParentPasscode,
          oRequest
        );
        // if this API returns 200, we have a full match
        this.kidLookupMatch = true;
        this.kidLookupNoMatch = false;
      } catch (err) {
        console.log(err);
        // if it returns an error, there is no match
        // the error type returned by the server here
        // may allow us to give more information to the user
        this.kidLookupMatch = false;
        this.kidLookupNoMatch = true;
        this.bErrorStateIsBlocking = false;
        if (err instanceof httpStatusException) {
          if (err.errorType === "NO_PEOPLE") {
            this.strCustomErrorMessage =
              "No match found (because this school has not yet imported kids/teachers into their yearbook).";
          } else if (err.errorType === "KID_ALREADY_EXISTS") {
            this.strCustomErrorMessage =
              "Kid already exists. Close this dialog and click 'Select Existing Kid' instead.";
            this.bErrorStateIsBlocking = true;
          } else if (err.httpCode == 500) {
            this.strCustomErrorMessage =
              "An error occurred looking up your kid's information. Please try again.";
            this.bErrorStateIsBlocking = true;
          } else {
            this.strCustomErrorMessage = null;
          }
        }
      } finally {
        this.apiVerifyKidInformationInProgress = false;
      }
    },
    fnOnClickAddKid() {
      this.fnAddBookInfoToKid(
        this.getParentPasscode,
        this.getStorefrontBookId,
        this.form.grade,
        this.form.teacher_name,
        this.getOrderId,
        this.selectedKidId
      );
    },
    async fnAddBookInfoToKid(
      inPasscode,
      inBookId,
      inGrade,
      inTeacher,
      inOrderId,
      inKidId = null
    ) {
      this.apiAddKidInProgress = true;
      this.kidLookupMatch = false;
      this.kidLookupNoMatch = false;
      try {
        // the user wants to add this kid to their order
        // if this is a new kid, create one on the server
        // otherwise, supply the existing id
        if (!inKidId) {
          let oParams = Object.assign({}, this.form);
          if (oParams.grade === "n/a") oParams.grade = null;
          if (oParams.teacher_name === "n/a") oParams.teacher_name = null;
          const oRequest = {
            ...oParams,
            book_id: inBookId,
            passcode: inPasscode
          };
          const res = await this.createKid(oRequest);
          inKidId = res.id;
        } else {
          // existing kid was selected
          // update the info if the user went to edit it
          if (this.kidInfoIsEditable) {
            let oParams = Object.assign({}, this.form);
            if (oParams.grade === "n/a") oParams.grade = null;
            if (oParams.teacher_name === "n/a") oParams.teacher_name = null;
            await this.updateKidInfo({
              kidId: inKidId,
              oParams: oParams
            });
          }
        }
        await this.addKidToOrder({ orderId: inOrderId, kidId: inKidId });
        this.fnCloseDlg();
      } catch (err) {
        console.log(err);
        this.fnAbortOnExceptionHandler(
          "An error occurred trying to add your kid. Please try again"
        );
      } finally {
        this.apiAddKidInProgress = false;
      }
    },
    async onFormValidate(formItemName, bIsValid) {
      // every time the form is validated,
      // if we have all the kid's info
      // double check the info against the people DB
      if (
        this.form.first_name &&
        this.form.last_name &&
        this.form.grade &&
        this.form.teacher_name &&
        bIsValid
      ) {
        this.formIsValid = true;
        if (this.kidInfoIsEditable) {
          await this.fnVerifyKidInformation();
        }
      }
    },
    fnOnKidSelectChange() {
      const selectedKid = this.getKidsInfo.find(
        kid => kid.id === this.selectedKidId
      );
      // in existing kid mode, first_name/last_name inputs
      // are replaced with a kid dropdown
      // when the kid dropdown is changed, we simply
      // map the first_name/last_name attributes from the kid object
      // to to the form object
      // this allows the rest of this component's validation logic
      // to work as normal
      this.form.first_name = selectedKid.first_name;
      this.form.last_name = selectedKid.last_name;
      this.form.teacher_name = selectedKid.teacher_name || "n/a";
      this.form.grade = selectedKid.grade || "n/a";
      this.formIsValid = true;
    },
    // generic close the dialog/show error message on exception handler
    fnAbortOnExceptionHandler(
      errorMessage = `Sorry an error occurred looking up your kid's information`
    ) {
      this.$message({
        message: errorMessage,
        type: "error"
      });
      this.fnCloseDlg();
    }
  },
  async mounted() {
    // if the user has already entered the parent passcode
    // we'll skip the login prompt and init
    if (this.getParentPasscode !== null) {
      await this.fnInitUiOptions();
    }
  }
};
</script>
<style>
.shakeanim {
  -webkit-animation: kf_shake 0.4s 1 linear;
  -moz-animation: kf_shake 0.4s 1 linear;
  -o-animation: kf_shake 0.4s 1 linear;
}
@-webkit-keyframes kf_shake {
  0% {
    -webkit-transform: translate(30px);
  }
  20% {
    -webkit-transform: translate(-30px);
  }
  40% {
    -webkit-transform: translate(15px);
  }
  60% {
    -webkit-transform: translate(-15px);
  }
  80% {
    -webkit-transform: translate(8px);
  }
  100% {
    -webkit-transform: translate(0px);
  }
}
@-moz-keyframes kf_shake {
  0% {
    -moz-transform: translate(30px);
  }
  20% {
    -moz-transform: translate(-30px);
  }
  40% {
    -moz-transform: translate(15px);
  }
  60% {
    -moz-transform: translate(-15px);
  }
  80% {
    -moz-transform: translate(8px);
  }
  100% {
    -moz-transform: translate(0px);
  }
}
@-o-keyframes kf_shake {
  0% {
    -o-transform: translate(30px);
  }
  20% {
    -o-transform: translate(-30px);
  }
  40% {
    -o-transform: translate(15px);
  }
  60% {
    -o-transform: translate(-15px);
  }
  80% {
    -o-transform: translate(8px);
  }
  100% {
    -o-origin-transform: translate(0px);
  }
}
/* this disables the green border effect for form elements which are valid */
.mykids-form-item.el-form-item.is-success .el-input__inner,
.mykids-form-item-form-item.el-form-item.is-success .el-input__inner:focus,
.mykids-form-item-form-item.el-form-item.is-success .el-textarea__inner,
.mykids-form-item-form-item.el-form-item.is-success .el-textarea__inner:focus {
  border-color: #dcdfe6;
}
</style>
